/**
 * An arrival's read-only details: every field, every bag weighed, every reweigh, the timeline. A
 * sibling of `$id` (the trailing `_` keeps it from nesting inside the form), not a tab of it.
 */
import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { ArrivalDetailsPage } from "@/features/arrival/components/details/arrival-details-page";
import { formCodeOf, isFormSlug } from "@/features/arrival/forms";
import { useAuth } from "@/features/auth/store";

export const Route = createFileRoute("/_app/arrivals/$form/$id_/details")({
  params: {
    parse: ({ form, id }) => {
      if (!isFormSlug(form) || !/^\d+$/.test(id)) throw notFound();
      return { form, id };
    },
    stringify: (p) => p,
  },
  beforeLoad: ({ params }) => {
    const auth = useAuth.getState();
    if (
      !auth.can("document.view") ||
      !auth.canViewForm(formCodeOf(params.form))
    )
      throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const { id } = Route.useParams();
  return <ArrivalDetailsPage id={Number(id)} />;
}
